import { AxiosResponse } from 'axios'
import { GET_API_TOKEN, API_BASE_URL } from '../../constants/apiConstants'
import { LOCAL_TIME_ZONE } from '../../constants/defaults'
import axios from '../../helpers/Axios'
import { VisualizationCsvDataResponseType } from '../../types/SensorType'

export const getVisualizationData = async (
    patientKey: string,
    startTime: number,
    endTime: number
  ): Promise<Object> => {
    return axios({
      method: 'get',
      // baseURL: "http://localhost:8080/Anidra-2.6.2-Aus",
      baseURL: API_BASE_URL,
      url: `/api/rpmweb/sensors/visualization/${patientKey}/${startTime}/${endTime}`,
      headers: {
        Authorization: `Bearer ${GET_API_TOKEN()}`,
      },
    })
  }

export const getVisualizationDataFile = async (
  patientKey: string,
    startTime: number,
    endTime: number
): Promise<AxiosResponse<VisualizationCsvDataResponseType | undefined>> => {
  return axios({
    method: 'get',
    // baseURL: "http://localhost:8080/Anidra-2.6.2-Aus",
    baseURL: API_BASE_URL,
    url: `/api/rpmweb/sensors/visualization/csv/${patientKey}/${startTime}/${endTime}?timeZone=${LOCAL_TIME_ZONE}`,
    headers: {
      Authorization: `Bearer ${GET_API_TOKEN()}`,
    },
  })
}
  